import { Request } from 'fetchboi'

export const getCourses = Request.register({
    endpoint: '/courses',
    method: 'get',
    useAuthentication: true
})

export const getCoursesMetrics = Request.register({
    endpoint: '/courses/:id/metrics',
    method: 'get',
    useAuthentication: true
})

export const getCourse = Request.register({
    endpoint: '/courses/:id',
    method: 'get',
    useAuthentication: true
})

export const addCourse = Request.register({
    endpoint: '/courses',
    method: 'post',
    useAuthentication: true
})

export const editCourse = Request.register({
    endpoint: '/courses/:id',
    method: 'put',
    useAuthentication: true
})

export const deleteCourse = Request.register({
    endpoint: '/courses/:id',
    method: 'delete',
    useAuthentication: true
})


// WEBPACK FOOTER //
// ./src/requests/courses.js